<template>
  <div class="fixed inset-0 z-10 bg-black bg-opacity-40 flex justify-center items-center">
    <div class="w-96 rounded-lg p-6 bg-white shadow-lg">
      <div class="flex justify-between items-center">
        <p class="font-bold">{{ isAll ? $t('lmsSms.all') : '' }} {{$t('lmsSms.sendSmsButton')}}</p>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="mt-3">
        <GrmTextarea v-model="content" ref="content" />
        <GrmBtn class="w-full" @click="onSendSMS">{{$t('lmsSms.send')}}</GrmBtn>
      </div>
    </div>
  </div>
</template>

<script>
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";
import GrmTextarea from "@/components/Common/textarea/GrmTextarea.vue";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'RoomLmsSMS',
  components: {
    GrmBtn,
    GrmTextarea,
    GrmCloseBtn
  },
  data() {
    return {
      content: ''
    }
  },
  computed: {
    ...mapGetters('lms', [
      'lmsUserIdList'
    ]),

    target() {
      return this.$parent.target
    },
    isAll() {
      return this.target === 'all'
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.content.$refs.textarea.focus()
    }, 50)
  },
  methods: {
    ...mapActions('lms', [
      'sendSMSToLmsUser',
      'sendSMSToAllLmsUser'
    ]),

    onClose() {
      this.$modal('RoomLmsSMS')
    },
    onSendSMS() {
      this.$alert({
        text: this.$t('lmsSms.sendSms'),
        ok: async () => {
          try {
            if (this.isAll) {
              await this.sendSMSToAllLmsUser({
                userIds: this.lmsUserIdList,
                msgType: 'SMS',
                content: this.content
              })
            } else {
              await this.sendSMSToLmsUser({
                userId: this.target.userId,
                msgType: 'SMS',
                content: this.content
              })
            }

            this.$alert(this.$t('lmsSms.completeSms'))
          } catch (e) {
            switch(e.code) {
              case 'RT_NOT_SUPPORT':
                this.$alert(this.$t('lmsSms.userNotFound'))
                break;
              default:
                this.$alert(this.$t('lmsSms.smsFail'))
                break;
            }
          }
        }
      })
    }
  }
}
</script>